import { useShow } from "@refinedev/core";
import {
    Show,
    NumberField,
    TextFieldComponent as TextField,
    MarkdownField,
    DateField,
} from "@refinedev/mui";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";

export const UserShow = () => {
    const { queryResult } = useShow();
    const { data, isLoading } = queryResult;

    const record = data?.data;
console.log("UserShow record: ", record);

    return (
        <Show isLoading={isLoading}>
            <Stack gap={1}>
                <Typography variant="body1" fontWeight="bold">
                    로그인 Id
                </Typography>
                <TextField value={record?.loginId ?? ""} />
                <Typography variant="body1" fontWeight="bold">
                    이름
                </Typography>
                <TextField value={record?.nickName} />
                <Typography variant="body1" fontWeight="bold">
                    권한
                </Typography>
                <TextField value={record?.auth} />
                <Typography variant="body1" fontWeight="bold">
                    전화번호
                </Typography>
                <TextField value={record?.phoneNumber} />
            </Stack>
        </Show>
    );
};